"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalEventDealer = exports.getGlobalEventByName = exports.SOCIETY_COLONY_GLOBAL_EVENTS = exports.SOCIETY_VENUS_GLOBAL_EVENTS = exports.SOCIETY_GLOBAL_EVENTS = void 0;
const GlobalEventName_1 = require("./GlobalEventName");
const GlobalDustStorm_1 = require("./GlobalDustStorm");
const SponsoredProjects_1 = require("./SponsoredProjects");
const AsteroidMining_1 = require("./AsteroidMining");
const GenerousFunding_1 = require("./GenerousFunding");
const SuccessfulOrganisms_1 = require("./SuccessfulOrganisms");
const Productivity_1 = require("./Productivity");
const EcoSabotage_1 = require("./EcoSabotage");
const HomeworldSupport_1 = require("./HomeworldSupport");
const MinersOnStrike_1 = require("./MinersOnStrike");
const MudSlides_1 = require("./MudSlides");
const Revolution_1 = require("./Revolution");
const Riots_1 = require("./Riots");
const Sabotage_1 = require("./Sabotage");
const SnowCover_1 = require("./SnowCover");
const VolcanicEruptions_1 = require("./VolcanicEruptions");
const InterplanetaryTrade_1 = require("./InterplanetaryTrade");
const ImprovedEnergyTemplates_1 = require("./ImprovedEnergyTemplates");
const WarOnEarth_1 = require("./WarOnEarth");
const Pandemic_1 = require("./Pandemic");
const Diversity_1 = require("./Diversity");
const CelebrityLeaders_1 = require("./CelebrityLeaders");
const SpinoffProducts_1 = require("./SpinoffProducts");
const Election_1 = require("./Election");
const AquiferReleasedByPublicCouncil_1 = require("./AquiferReleasedByPublicCouncil");
const ParadigmBreakdown_1 = require("./ParadigmBreakdown");
const CorrosiveRain_1 = require("./CorrosiveRain");
const JovianTaxRights_1 = require("./JovianTaxRights");
const DryDeserts_1 = require("./DryDeserts");
const ScientificCommunity_1 = require("./ScientificCommunity");
const RedInfluence_1 = require("./RedInfluence");
const SolarnetShutdown_1 = require("./SolarnetShutdown");
const StrongSociety_1 = require("./StrongSociety");
const SolarFlare_1 = require("./SolarFlare");
const VenusInfrastructure_1 = require("./VenusInfrastructure");
const CloudSocieties_1 = require("./CloudSocieties");
const MicrogravityHealthProblems_1 = require("./MicrogravityHealthProblems");
const FermiSolution_1 = require("./society/FermiSolution");
const OperationDaedalus_1 = require("./society/OperationDaedalus");
const ClimateImpact_1 = require("./society/ClimateImpact");
const Gerontocracy_1 = require("./society/Gerontocracy");
const MetaSpirituality_1 = require("./society/MetaSpirituality");
const UniversalRoom_1 = require("./society/UniversalRoom");
const ExhaltSpecies_1 = require("./society/ExhaltSpecies");
const AdaptedPathogens_1 = require("./society/AdaptedPathogens");
const ColonizationIncentives_1 = require("./society/ColonizationIncentives");
const SolarCryptocurrency_1 = require("./society/SolarCryptocurrency");
const SmugglingActivity_1 = require("./society/SmugglingActivity");
const GenomeControl_1 = require("./society/GenomeControl");
const VerdantEconomy_1 = require("./society/VerdantEconomy");
const ControlledTectonics_1 = require("./society/ControlledTectonics");
const RaidOnPrivateers_1 = require("./society/RaidOnPrivateers");
const DutyFreeSpace_1 = require("./society/DutyFreeSpace");
const Renationalisation_1 = require("./society/Renationalisation");
const TechnologicalTelepathy_1 = require("./society/TechnologicalTelepathy");
const VirtualDemocracy_1 = require("./society/VirtualDemocracy");
const ClosedBiospheres_1 = require("./society/ClosedBiospheres");
const ExtrasolarRace_1 = require("./society/ExtrasolarRace");
const SocialNihilism_1 = require("./society/SocialNihilism");
const DysonSwarmConstruction_1 = require("./society/DysonSwarmConstruction");
const MagneticShield_1 = require("./society/MagneticShield");
const PowerTrip_1 = require("./society/PowerTrip");
const ConnectedCommunities_1 = require("./society/ConnectedCommunities");
const PlanetFederation_1 = require("./society/PlanetFederation");
const TransparentPolitics_1 = require("./society/TransparentPolitics");
const PreferentialLoans_1 = require("./society/PreferentialLoans");
const KesslersBlast_1 = require("./society/KesslersBlast");
const PhaetonRescue_1 = require("./society/PhaetonRescue");
const Bioplague_1 = require("./society/Bioplague");
const AtmosphericCompression_1 = require("./society/AtmosphericCompression");
const WoodlandInitiatives_1 = require("./society/WoodlandInitiatives");
const ThermalFusion_1 = require("./society/ThermalFusion");
const BloomingVale_1 = require("./society/BloomingVale");
const COLONY_ONLY_POSITIVE_GLOBAL_EVENTS = new Map([
    [GlobalEventName_1.GlobalEventName.JOVIAN_TAX_RIGHTS, JovianTaxRights_1.JovianTaxRights],
]);
const COLONY_ONLY_NEGATIVE_GLOBAL_EVENTS = new Map([
    [GlobalEventName_1.GlobalEventName.MICROGRAVITY_HEALTH_PROBLEMS, MicrogravityHealthProblems_1.MicrogravityHealthProblems],
]);
const VENUS_COLONY_POSITIVE_GLOBAL_EVENTS = new Map([
    [GlobalEventName_1.GlobalEventName.CLOUD_SOCIETIES, CloudSocieties_1.CloudSocieties],
]);
const VENUS_COLONY_NEGATIVE_GLOBAL_EVENTS = new Map([
    [GlobalEventName_1.GlobalEventName.CORROSIVE_RAIN, CorrosiveRain_1.CorrosiveRain],
]);
const VENUS_POSITIVE_GLOBAL_EVENTS = new Map([
    [GlobalEventName_1.GlobalEventName.VENUS_INFRASTRUCTURE, VenusInfrastructure_1.VenusInfrastructure],
]);
const POSITIVE_GLOBAL_EVENTS = new Map([
    [GlobalEventName_1.GlobalEventName.SPONSORED_PROJECTS, SponsoredProjects_1.SponsoredProjects],
    [GlobalEventName_1.GlobalEventName.ASTEROID_MINING, AsteroidMining_1.AsteroidMining],
    [GlobalEventName_1.GlobalEventName.GENEROUS_FUNDING, GenerousFunding_1.GenerousFunding],
    [GlobalEventName_1.GlobalEventName.SUCCESSFUL_ORGANISMS, SuccessfulOrganisms_1.SuccessfulOrganisms],
    [GlobalEventName_1.GlobalEventName.PRODUCTIVITY, Productivity_1.Productivity],
    [GlobalEventName_1.GlobalEventName.HOMEWORLD_SUPPORT, HomeworldSupport_1.HomeworldSupport],
    [GlobalEventName_1.GlobalEventName.VOLCANIC_ERUPTIONS, VolcanicEruptions_1.VolcanicEruptions],
    [GlobalEventName_1.GlobalEventName.DIVERSITY, Diversity_1.Diversity],
    [GlobalEventName_1.GlobalEventName.IMPROVED_ENERGY_TEMPLATES, ImprovedEnergyTemplates_1.ImprovedEnergyTemplates],
    [GlobalEventName_1.GlobalEventName.INTERPLANETARY_TRADE, InterplanetaryTrade_1.InterplanetaryTrade],
    [GlobalEventName_1.GlobalEventName.CELEBRITY_LEADERS, CelebrityLeaders_1.CelebrityLeaders],
    [GlobalEventName_1.GlobalEventName.SPINOFF_PRODUCTS, SpinoffProducts_1.SpinoffProducts],
    [GlobalEventName_1.GlobalEventName.ELECTION, Election_1.Election],
    [GlobalEventName_1.GlobalEventName.AQUIFER_RELEASED_BY_PUBLIC_COUNCIL, AquiferReleasedByPublicCouncil_1.AquiferReleasedByPublicCouncil],
    [GlobalEventName_1.GlobalEventName.SCIENTIFIC_COMMUNITY, ScientificCommunity_1.ScientificCommunity],
    [GlobalEventName_1.GlobalEventName.STRONG_SOCIETY, StrongSociety_1.StrongSociety],
]);
const NEGATIVE_GLOBAL_EVENTS = new Map([
    [GlobalEventName_1.GlobalEventName.GLOBAL_DUST_STORM, GlobalDustStorm_1.GlobalDustStorm],
    [GlobalEventName_1.GlobalEventName.ECO_SABOTAGE, EcoSabotage_1.EcoSabotage],
    [GlobalEventName_1.GlobalEventName.MINERS_ON_STRIKE, MinersOnStrike_1.MinersOnStrike],
    [GlobalEventName_1.GlobalEventName.MUD_SLIDES, MudSlides_1.MudSlides],
    [GlobalEventName_1.GlobalEventName.REVOLUTION, Revolution_1.Revolution],
    [GlobalEventName_1.GlobalEventName.RIOTS, Riots_1.Riots],
    [GlobalEventName_1.GlobalEventName.SABOTAGE, Sabotage_1.Sabotage],
    [GlobalEventName_1.GlobalEventName.SNOW_COVER, SnowCover_1.SnowCover],
    [GlobalEventName_1.GlobalEventName.PANDEMIC, Pandemic_1.Pandemic],
    [GlobalEventName_1.GlobalEventName.WAR_ON_EARTH, WarOnEarth_1.WarOnEarth],
    [GlobalEventName_1.GlobalEventName.PARADIGM_BREAKDOWN, ParadigmBreakdown_1.ParadigmBreakdown],
    [GlobalEventName_1.GlobalEventName.DRY_DESERTS, DryDeserts_1.DryDeserts],
    [GlobalEventName_1.GlobalEventName.RED_INFLUENCE, RedInfluence_1.RedInfluence],
    [GlobalEventName_1.GlobalEventName.SOLARNET_SHUTDOWN, SolarnetShutdown_1.SolarnetShutdown],
    [GlobalEventName_1.GlobalEventName.SOLAR_FLARE, SolarFlare_1.SolarFlare],
]);
exports.SOCIETY_GLOBAL_EVENTS = new Map([
    [GlobalEventName_1.GlobalEventName.ADAPTED_PATHOGENS, AdaptedPathogens_1.AdaptedPathogens],
    [GlobalEventName_1.GlobalEventName.BIOPLAGUE, Bioplague_1.Bioplague],
    [GlobalEventName_1.GlobalEventName.BLOOMING_VALE, BloomingVale_1.BloomingVale],
    [GlobalEventName_1.GlobalEventName.CLIMATE_IMPACT, ClimateImpact_1.ClimateImpact],
    [GlobalEventName_1.GlobalEventName.CLOSED_BIOSPHERES, ClosedBiospheres_1.ClosedBiospheres],
    [GlobalEventName_1.GlobalEventName.CONNECTED_COMMUNITIES, ConnectedCommunities_1.ConnectedCommunities],
    [GlobalEventName_1.GlobalEventName.DYSON_SWARM_CONSTRUCTION, DysonSwarmConstruction_1.DysonSwarmConstruction],
    [GlobalEventName_1.GlobalEventName.EXHALT_SPECIES, ExhaltSpecies_1.ExhaltSpecies],
    [GlobalEventName_1.GlobalEventName.EXTRASOLAR_RACE, ExtrasolarRace_1.ExtrasolarRace],
    [GlobalEventName_1.GlobalEventName.GENOME_CONTROL, GenomeControl_1.GenomeControl],
    [GlobalEventName_1.GlobalEventName.GERONTOCRACY, Gerontocracy_1.Gerontocracy],
    [GlobalEventName_1.GlobalEventName.KESSLERS_BLAST, KesslersBlast_1.KesslersBlast],
    [GlobalEventName_1.GlobalEventName.MAGNETIC_SHIELD, MagneticShield_1.MagneticShield],
    [GlobalEventName_1.GlobalEventName.META_SPIRITUALITY, MetaSpirituality_1.MetaSpirituality],
    [GlobalEventName_1.GlobalEventName.PLANET_FEDERATION, PlanetFederation_1.PlanetFederation],
    [GlobalEventName_1.GlobalEventName.POWER_TRIP, PowerTrip_1.PowerTrip],
    [GlobalEventName_1.GlobalEventName.PREFERENTIAL_LOANS, PreferentialLoans_1.PreferentialLoans],
    [GlobalEventName_1.GlobalEventName.RAID_ON_PRIVATEERS, RaidOnPrivateers_1.RaidOnPrivateers],
    [GlobalEventName_1.GlobalEventName.RENATIONALISATION, Renationalisation_1.Renationalisation],
    [GlobalEventName_1.GlobalEventName.SOCIAL_NIHILISM, SocialNihilism_1.SocialNihilism],
    [GlobalEventName_1.GlobalEventName.SOLAR_CRYPTOCURRENCY, SolarCryptocurrency_1.SolarCryptocurrency],
    [GlobalEventName_1.GlobalEventName.TECHNOLOGICAL_TELEPATHY, TechnologicalTelepathy_1.TechnologicalTelepathy],
    [GlobalEventName_1.GlobalEventName.THERMAL_FUSION, ThermalFusion_1.ThermalFusion],
    [GlobalEventName_1.GlobalEventName.TRANSPARENT_POLITICS, TransparentPolitics_1.TransparentPolitics],
    [GlobalEventName_1.GlobalEventName.UNIVERSAL_ROOM, UniversalRoom_1.UniversalRoom],
    [GlobalEventName_1.GlobalEventName.VERDANT_ECONOMY, VerdantEconomy_1.VerdantEconomy],
    [GlobalEventName_1.GlobalEventName.VIRTUAL_DEMOCRACY, VirtualDemocracy_1.VirtualDemocracy],
    [GlobalEventName_1.GlobalEventName.WOODLAND_INITIATIVES, WoodlandInitiatives_1.WoodlandInitiatives],
]);
exports.SOCIETY_VENUS_GLOBAL_EVENTS = new Map([
    [GlobalEventName_1.GlobalEventName.ATMOSPHERIC_COMPRESSION, AtmosphericCompression_1.AtmosphericCompression],
    [GlobalEventName_1.GlobalEventName.CONTROLLED_TECTONICS, ControlledTectonics_1.ControlledTectonics],
    [GlobalEventName_1.GlobalEventName.DUTY_FREE_SPACE, DutyFreeSpace_1.DutyFreeSpace],
]);
exports.SOCIETY_COLONY_GLOBAL_EVENTS = new Map([
    [GlobalEventName_1.GlobalEventName.COLONIZATION_INCENTIVES, ColonizationIncentives_1.ColonizationIncentives],
    [GlobalEventName_1.GlobalEventName.FERMI_SOLUTION, FermiSolution_1.FermiSolution],
    [GlobalEventName_1.GlobalEventName.OPERATION_DAEDALUS, OperationDaedalus_1.OperationDaedalus],
    [GlobalEventName_1.GlobalEventName.PHAETON_RESCUE, PhaetonRescue_1.PhaetonRescue],
    [GlobalEventName_1.GlobalEventName.SMUGGLING_ACTIVITY, SmugglingActivity_1.SmugglingActivity],
]);
const RENAMED_GLOBAL_EVENTS = new Map([]);
const ALL_EVENTS = new Map([
    ...Array.from(POSITIVE_GLOBAL_EVENTS),
    ...Array.from(NEGATIVE_GLOBAL_EVENTS),
    ...Array.from(COLONY_ONLY_POSITIVE_GLOBAL_EVENTS),
    ...Array.from(COLONY_ONLY_NEGATIVE_GLOBAL_EVENTS),
    ...Array.from(VENUS_COLONY_POSITIVE_GLOBAL_EVENTS),
    ...Array.from(VENUS_COLONY_NEGATIVE_GLOBAL_EVENTS),
    ...Array.from(VENUS_POSITIVE_GLOBAL_EVENTS),
    ...Array.from(exports.SOCIETY_GLOBAL_EVENTS),
    ...Array.from(exports.SOCIETY_VENUS_GLOBAL_EVENTS),
    ...Array.from(exports.SOCIETY_COLONY_GLOBAL_EVENTS),
    ...Array.from(RENAMED_GLOBAL_EVENTS),
]);
function getGlobalEventByName(globalEventName) {
    const Factory = ALL_EVENTS.get(globalEventName);
    if (Factory !== undefined)
        return new Factory();
    return undefined;
}
exports.getGlobalEventByName = getGlobalEventByName;
class GlobalEventDealer {
    constructor(globalEventsDeck, discardedGlobalEvents) {
        this.globalEventsDeck = globalEventsDeck;
        this.discardedGlobalEvents = discardedGlobalEvents;
    }
    static newInstance(game) {
        let globalEventsDeck;
        let events = [];
        const societyExpansionEnabled = game.gameOptions.societyExpansion;
        if (societyExpansionEnabled === true) {
            events.push(...Array.from(exports.SOCIETY_GLOBAL_EVENTS));
            if (game.gameOptions.venusNextExtension)
                events.push(...Array.from(exports.SOCIETY_VENUS_GLOBAL_EVENTS));
            if (game.gameOptions.coloniesExtension)
                events.push(...Array.from(exports.SOCIETY_COLONY_GLOBAL_EVENTS));
            if (game.gameOptions.randomTurmoil)
                this.addOfficialGlobalEventsToDeck(game, events);
        }
        else {
            this.addOfficialGlobalEventsToDeck(game, events);
        }
        globalEventsDeck = this.shuffle(events.map((cf) => new cf[1]));
        if (game.gameOptions.randomTurmoil)
            globalEventsDeck = globalEventsDeck.slice(0, 36);
        return new GlobalEventDealer(globalEventsDeck, []);
    }
    ;
    static addOfficialGlobalEventsToDeck(game, events) {
        events.push(...Array.from(POSITIVE_GLOBAL_EVENTS));
        events.push(...Array.from(NEGATIVE_GLOBAL_EVENTS));
        if (game.gameOptions.coloniesExtension)
            events.push(...Array.from(COLONY_ONLY_NEGATIVE_GLOBAL_EVENTS));
        if (game.gameOptions.coloniesExtension)
            events.push(...Array.from(COLONY_ONLY_POSITIVE_GLOBAL_EVENTS));
        if (game.gameOptions.venusNextExtension)
            events.push(...Array.from(VENUS_POSITIVE_GLOBAL_EVENTS));
        if (game.gameOptions.venusNextExtension && game.gameOptions.coloniesExtension) {
            events.push(...Array.from(VENUS_COLONY_POSITIVE_GLOBAL_EVENTS));
            events.push(...Array.from(VENUS_COLONY_NEGATIVE_GLOBAL_EVENTS));
        }
    }
    static shuffle(cards) {
        const deck = [];
        const copy = cards.slice();
        while (copy.length) {
            deck.push(copy.splice(Math.floor(Math.random() * copy.length), 1)[0]);
        }
        return deck;
    }
    draw() {
        return this.globalEventsDeck.pop();
    }
    serialize() {
        return {
            deck: this.globalEventsDeck.map((card) => {
                return { name: card.name, currentDelegate: card.currentDelegate, revealedDelegate: card.revealedDelegate };
            }),
            discarded: this.discardedGlobalEvents.map((card) => {
                return { name: card.name, currentDelegate: card.currentDelegate, revealedDelegate: card.revealedDelegate };
            }),
        };
    }
    static deserialize(d) {
        const deck = d.deck.map((element) => {
            const event = getGlobalEventByName(element.name);
            event.currentDelegate = element.currentDelegate;
            event.revealedDelegate = element.revealedDelegate;
            return event;
        });
        const discardPile = d.discarded.map((element) => {
            const event = getGlobalEventByName(element.name);
            event.currentDelegate = element.currentDelegate;
            event.revealedDelegate = element.revealedDelegate;
            return event;
        });
        return new GlobalEventDealer(deck, discardPile);
    }
}
exports.GlobalEventDealer = GlobalEventDealer;
//# sourceMappingURL=GlobalEventDealer.js.map